import { PlotSeries } from "../../generated/graphql";

export const areAllChartValuesZero = (series: PlotSeries[]) => {
    return series?.every((serData) => serData.dataSeries.every((aggData) => aggData === 0));
};
